import { Common } from './common';
import {
  CreateValues,
  StripeAccount,
  UpdateValues,
} from './models/stripeAccount';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOneByAccountId(accountId: string): Promise<StripeAccount> {
    const url = this.common.constructPath(`/stripe-accounts/${accountId}`);
    const body = await this.common.getJSON(url);
    return body;
  }

  async findAllAccessible(
    livemode: boolean,
  ): Promise<{ name: string; accountId: string }[]> {
    const url = this.common.constructPath(`/stripe-accounts/accessible`, {
      livemode,
    });
    const { accounts } = await this.common.getJSON(url);
    return accounts;
  }

  async findAll(): Promise<StripeAccount[]> {
    const url = this.common.constructPath(`/stripe-accounts/`);
    const { results } = await this.common.getJSON(url);
    return results;
  }

  async create(values: CreateValues): Promise<StripeAccount> {
    const url = this.common.constructPath(`/stripe-accounts/`);
    const body = await this.common.postJSON(url, values);
    return body;
  }

  async updateByAccountId(
    accountId: string,
    values: UpdateValues,
  ): Promise<StripeAccount> {
    const url = this.common.constructPath(`/stripe-accounts/${accountId}`);
    const body = await this.common.patchJSON(url, values);
    return body;
  }
}
